import { getInstance as getBootstrap } from 'utils/bootstrap';
import { getGoogleMapsApiClient } from 'lib/GoogleMapsApiClient';
import Logger from 'observability/Logger';

const LOG = new Logger('LocationSearchInput-lib');
let placesLibrary;

function getApiKeyFromBootstrap() {
    const bootstrap = getBootstrap();
    const googleMapsApiKey = bootstrap.get('googleMapsApiKey');

    if (!googleMapsApiKey) {
        LOG.warn('No googleMapsApiKey');
    }
    return googleMapsApiKey;
}

function createGoogleAutocompleteService() {
    if (window.google) {
        return new window.google.maps.places.AutocompleteService();
    }

    return null;
}

function loadGoogleMapsPlacesLibrary(apiKey = getApiKeyFromBootstrap()) {
    const script = document.createElement('script');

    script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=places`;

    script.async = true;

    script.addEventListener('load', () => {
        placesLibrary = createGoogleAutocompleteService();
    });

    document.body.appendChild(script);
}

export const loadPlacesLibrary = (apiKey) => {
    if (window.google) {
        placesLibrary = createGoogleAutocompleteService();
    } else {
        loadGoogleMapsPlacesLibrary(apiKey);
    }
};

export const getPlaceSuggestions = (input, callback = () => {}) => {
    if (placesLibrary) {
        placesLibrary.getPlacePredictions({ input }, callback);
    } else {
        // Call the callback with an empty array of results
        callback([]);
    }
};

function formatGeocodeResults(geocodeData = {}) {
    const addressFields = {
        name: geocodeData.name,
        address: '',
        city: '',
        state: '',
        zipCode: '',
        country: '',
    };

    if (Array.isArray(geocodeData.address_components)) {
        geocodeData.address_components.forEach((addressComponent, index) => {
            if (addressComponent.types.includes('locality')) {
                addressFields.city = addressComponent.long_name;
            } else if (addressComponent.types.includes('administrative_area_level_1')) {
                addressFields.state = addressComponent.short_name;
            } else if (addressComponent.types.includes('postal_code')) {
                addressFields.zipCode = addressComponent.long_name;
            } else if (addressComponent.types.includes('country')) {
                addressFields.country = addressComponent.long_name;
            }
        });
    }

    if (typeof geocodeData.formatted_address === 'string') {
        addressFields.address = geocodeData.formatted_address.split(',')[0];
    }

    if (geocodeData.geometry) {
        addressFields.lat = geocodeData.geometry.location.lat();
        addressFields.lng = geocodeData.geometry.location.lng();
    }

    if (geocodeData.utc_offset) {
        addressFields.utc_offset = geocodeData.utc_offset;
    }

    return addressFields;
}

export const getPlaceDetailsByPlaceId = (placeId) => {
    if (!window.google && !window.google.maps) {
        return Promise.reject(new Error('No Google Maps library initialized'));
    }
    // The PlacesService requires an element node in it's constructor function
    const placeService = new window.google.maps.places.PlacesService(document.createElement('div'));
    const { OK } = window.google.maps.places.PlacesServiceStatus;

    return new Promise((resolve, reject) => {
        placeService.getDetails({ placeId }, (results, status) => {
            if (status !== OK) {
                reject(results);
            }

            const placeDetails = formatGeocodeResults(results);
            getGoogleMapsApiClient()
                .getLocationTimezone({
                    latitude: placeDetails.lat,
                    longitude: placeDetails.lng,
                })
                .then((result) => {
                    resolve({ ...placeDetails, time_zone: result.timeZoneId });
                });
        });
    });
};
